import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";

import {Observable} from "rxjs";
import {AuthenticationService} from "../../services";
import {tap} from "rxjs/operators";
import {StateService} from "../../services/state/state.service";
import {NotificationService} from "@tva/ng-migration/uicomponents";
import {schoolwork12} from "@tva/ng-migration/common/util";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private auth: AuthenticationService, private state: StateService, private notification: NotificationService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    const keyCode = this.auth.getKeyCode();

    const authReq = req.clone({
      headers: req.headers.set("X-API-TOKEN", keyCode)
    });

    return this.handleResponses(next.handle(authReq));
  }

  handleResponses(next: Observable<HttpEvent<any>>): Observable<HttpEvent<any>> {
    const handle401 = (err) => {
      if (this.auth.isAuthenticated()) {
        const message = err?.error?._errors?.[0] || schoolwork12.app.errorMessages.sessionExpired;
        this.notification.showErrorMessage(message);
      }
    };

    return next.pipe(tap(()=>{}, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          return handle401(err);
        }
      }
    }));
  }
}
